import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Save } from "lucide-react";

const FIELDS = [
  { k: "instructions", label: "Οδηγίες προς τον agent", rows: 7, ph: "π.χ. Απαντάς πάντα στον πληθυντικό. Σε ερωτήσεις για καταλόγους προτείνεις το ADVANCED (150€ + ΦΠΑ). Δεν δίνεις εκπτώσεις χωρίς έγκρισή μου…" },
  { k: "style", label: "Ύφος γραφής (από την εκπαίδευση)", rows: 4 },
  { k: "signature", label: "Υπογραφή", rows: 4 },
  { k: "knowledge", label: "Γνώσεις που χρησιμοποιεί (τιμές, υπηρεσίες, πολιτικές)", rows: 10 },
];

export const AgentKnowledge = ({ cfg, reload }) => {
  const init = () => ({ instructions: cfg.instructions || "", style: cfg.profile?.style || "", signature: cfg.profile?.signature || "", knowledge: cfg.profile?.knowledge || "" });
  const [f, setF] = useState(init);
  const [saving, setSaving] = useState(false);
  useEffect(() => setF(init()), [cfg.profile?.updated_at]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    setSaving(true);
    try { await api.patch("/email-agent", f); toast.success("Αποθηκεύτηκε"); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Σφάλμα"); }
    finally { setSaving(false); }
  };
  return (
    <section className="border border-slate-200 rounded-lg p-5 bg-white space-y-4" data-testid="email-agent-knowledge">
      {FIELDS.map(({ k, label, rows, ph }) => (
        <div key={k}>
          <label className="text-xs font-semibold text-slate-700">{label}</label>
          <Textarea rows={rows} value={f[k]} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1 text-sm" data-testid={`email-agent-${k}-input`} />
        </div>
      ))}
      {cfg.profile?.faq?.length > 0 && (
        <details className="text-sm" data-testid="email-agent-faq">
          <summary className="cursor-pointer text-xs font-semibold text-slate-700">Συχνές ερωτήσεις που έμαθε ({cfg.profile.faq.length})</summary>
          <ul className="mt-2 space-y-2">
            {cfg.profile.faq.map((x, i) => <li key={i} className="text-slate-700"><b>{x.q}</b><br />{x.a}</li>)}
          </ul>
        </details>
      )}
      <Button onClick={save} disabled={saving} data-testid="email-agent-save-btn"><Save className="w-4 h-4 mr-1" /> Αποθήκευση</Button>
    </section>
  );
};
